globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import * as React from 'react';
import { listIconMap } from '@restworld/utils-common';
import Title from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PrimaryList = function PrimaryList(_ref) {
  var itemList = _ref.itemList,
      type = _ref.type;
  return /*#__PURE__*/_jsx(Wrapper, {
    children: itemList.map(function (_ref2) {
      var subTitle = _ref2.subTitle,
          label = _ref2.label,
          icon = _ref2.icon,
          info = _ref2.info,
          shouldBeVisible = _ref2.shouldBeVisible,
          key = _ref2.key;
      return /*#__PURE__*/_jsx(Item, {
        subTitle: subTitle,
        label: label,
        icon: icon,
        type: type,
        info: info,
        shouldBeVisible: shouldBeVisible
      }, key);
    })
  }, type);
};
export default PrimaryList;

var Item = function Item(_ref3) {
  var icon = _ref3.icon,
      label = _ref3.label,
      subTitle = _ref3.subTitle,
      type = _ref3.type,
      info = _ref3.info,
      _ref3$shouldBeVisible = _ref3.shouldBeVisible,
      shouldBeVisible = _ref3$shouldBeVisible === void 0 ? true : _ref3$shouldBeVisible;
  return /*#__PURE__*/_jsxs(ItemWrapper, {
    shouldBeVisible: shouldBeVisible,
    children: [icon && /*#__PURE__*/_jsx(IconWrapper, {
      type: type,
      children: listIconMap[icon]
    }), /*#__PURE__*/_jsxs(ItemListWrapper, {
      children: [/*#__PURE__*/_jsx(ItemTitle, {
        type: type,
        children: label
      }), /*#__PURE__*/_jsx(ItemDynamicLabel, {
        type: type,
        children: subTitle
      }), info && /*#__PURE__*/_jsx(Title, {
        fontSize: "small",
        textColor: "gray",
        content: info,
        fontWeight: "normal"
      }, "sub-title-info")]
    })]
  });
}; // --> parent > styled components


var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "listprimary__Wrapper",
  componentId: "sc-iyop2-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.25rem"
}); // --> child > styled components


var ItemWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "listprimary__ItemWrapper",
  componentId: "sc-iyop2-1"
})(["", " ", ""], {
  "display": "flex",
  "flexDirection": "row",
  "alignItems": "center"
}, function (_ref4) {
  var shouldBeVisible = _ref4.shouldBeVisible;
  return !shouldBeVisible && {
    "display": "none"
  };
});

var IconWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "listprimary__IconWrapper",
  componentId: "sc-iyop2-2"
})(["", " ", ""], {
  "display": "inline-flex",
  "height": "2.5rem",
  "width": "2.5rem",
  "flexShrink": "0",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "0.5rem"
}, function (_ref5) {
  var type = _ref5.type;
  return type === 'default' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(138 112 184 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  };
});

var ItemListWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "listprimary__ItemListWrapper",
  componentId: "sc-iyop2-3"
})({
  "marginLeft": "0.5rem",
  "display": "flex",
  "flexDirection": "column"
});

var ItemTitle = /*#__PURE__*/_styled.span.withConfig({
  displayName: "listprimary__ItemTitle",
  componentId: "sc-iyop2-4"
})(["", " ", ""], {
  "fontSize": "0.75rem",
  "lineHeight": "1rem"
}, function (_ref6) {
  var type = _ref6.type;
  return type === 'default' ? {
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  } : {
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgb(212 193 245 / var(--tw-text-opacity))"
  };
});

var ItemDynamicLabel = /*#__PURE__*/_styled.span.withConfig({
  displayName: "listprimary__ItemDynamicLabel",
  componentId: "sc-iyop2-5"
})(["", " ", "}"], {
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "fontWeight": "600"
}, function (_ref7) {
  var _ref7$type = _ref7.type,
      type = _ref7$type === void 0 ? 'default' : _ref7$type;
  return type === 'landing-card' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  } : {
    "--tw-text-opacity": "1",
    "color": "rgb(17 24 39 / var(--tw-text-opacity))"
  };
});